// // src/pages/dashboard/Dashboard.jsx
// import "../../styles/dashboard.css";
// import DashboardLayout from "./DashboardLayout";
// import useDashboard from "./useDashboard";

// import MyReflection from "../MyReflection/MyReflection";
// import TeamView from "../TeamView/TeamView";
// import Timesheet from "../Timesheet/Timesheet";
// import MySkills from "../MySkills/MySkills";
// import Report from "../Report/Report";

// import ReflectionForm from "./ReflectionForm";

// export default function Dashboard() {
//   const d = useDashboard();

//   if (!d.isLoggedIn) {
//     window.location.href = "/";
//     return null;
//   }

//   const name = d.profile?.Name || "User";
//   const firstLetter = d.email?.charAt(0).toUpperCase() || "U";

//   const logout = () => {
//     localStorage.clear();
//     window.location.href = "/";
//   };

//   const handleNavClick = (page) => {
//     d.setActivePage(page);
//     if (d.isMobile) d.setIsSidebarOpen(false);
//   };

//   const getPageTitle = () => {
//     const titles = {
//       reflection: "Reflection Workspace",
//       myreflection: "My Reflections",
//       team: "Team Insights",
//       timesheet: "Timesheet",
//       myskills: "My Skills",
//       report: "Reports",
//     };
//     return titles[d.activePage] || "Dashboard";
//   };

//   const getSubtitle = () =>
//     d.activePage === "reflection"
//       ? `Welcome back, ${name}. Capture your reflections with premium clarity.`
//       : "";

//   // Conditional sidebar items — Team View only for RoleID 1 or 2
//   const navItems = [
//     ["reflection", "💎", "Reflection"],
//     ["myreflection", "👤", "My Reflections"],
//     ...(d.userRole === 1 || d.userRole === 2 ? [["team", "👑", "Team View"]] : []),
//     ["timesheet", "⏱️", "Timesheet"],
//     ["myskills", "🧠", "My Skills"],
//     ["report", "📊", "Report"],
//   ];

//   return (
//     <>
//       <DashboardLayout
//         sidebar={
//           <aside
//             className={`diamond-sidebar ${
//               d.isMobile && d.isSidebarOpen ? "sidebar-open-ultra" : ""
//             }`}
//           >
//             <div className="sidebar-header-ultra logo-only-center">
//   <img
//     src="/logo.png"
//     alt="Suryojasvi Logo"
//     className="sidebar-main-logo"
//   />
// </div>


//             <nav className="ultra-nav">
//               {navItems.map(([key, icon, label]) => (
//                 <button
//                   key={key}
//                   className={`nav-item-ultra ${d.activePage === key ? "active" : ""}`}
//                   onClick={() => handleNavClick(key)}
//                 >
//                   <div className="nav-icon-ultra">{icon}</div>
//                   <span>{label}</span>
//                 </button>
//               ))}
//             </nav>

//             <div className="sidebar-footer-ultra">
//               <div className="user-profile-ultra">
//                 <div className="user-email-ultra">{d.email}</div>
//                 <div className="user-team-ultra">
//                   Team: <strong>{d.team?.length || 0}</strong>
//                 </div>
//               </div>
//               <button className="logout-btn-ultra" onClick={logout}>
//                 Logout 🚪
//               </button>
//             </div>
//           </aside>
//         }

//         header={
//           <header className="diamond-header header-flex-ultra">
//             <div className="header-content-ultra">
//               <div className="page-kicker-ultra">Premium Dashboard</div>
//               <h1 className="page-title-ultra">{getPageTitle()}</h1>
//               <p className="page-subtitle-ultra">{getSubtitle()}</p>
//             </div>

//             <div className="header-user-chip">
//               <span className="chip-text">{name}</span>
//               <button
//                 className={`reminder-bell-btn ${d.hasNewReminder ? "has-reminder" : ""}`}
//                 onClick={() => d.setShowReminderPanel(true)}
//               >
//                 🔔
//               </button>
//             </div>
//           </header>
//         }

//         footer={
//           <footer className="diamond-footer">
//             <div className="footer-content">
//               <div className="footer-bottom">
//                 <div className="copyright">
//                   © {new Date().getFullYear()} Suryojasvi Reflection Tracker
//                 </div>
//               </div>
//             </div>
//           </footer>
//         }
//       >
//         {d.activePage === "reflection" && <ReflectionForm {...d} />}

//         {d.activePage === "myreflection" && (
//           <div className="diamond-card">
//             <div className="card-body-ultra">
//               <MyReflection />
//             </div>
//           </div>
//         )}

//         {d.activePage === "team" && (
//           d.userRole === 1 || d.userRole === 2 ? (
//             <div className="diamond-card">
//               <div className="card-body-ultra">
//                 <TeamView loggedEmail={d.email} teamData={d.team} />
//               </div>
//             </div>
//           ) : (
//             <div className="empty-state-ultra">No access to Team View.</div>
//           )
//         )}

//         {d.activePage === "timesheet" && (
//           <div className="diamond-card">
//             <div className="card-header-ultra">
//               <h2 className="card-title-ultra">Timesheet</h2>
//             </div>
//             <div className="card-body-ultra">
//               <Timesheet />
//             </div>
//           </div>
//         )}

//         {d.activePage === "myskills" && (
//           <div className="diamond-card">
//             <div className="card-header-ultra">
//               <h2 className="card-title-ultra">My Skills</h2>
//             </div>
//             <div className="card-body-ultra">
//               <MySkills />
//             </div>
//           </div>
//         )}

//         {d.activePage === "report" && (
//           <div className="diamond-card">
//             <div className="card-header-ultra">
//               <h2 className="card-title-ultra">Reports</h2>
//             </div>
//             <div className="card-body-ultra">
//               <Report />
//             </div>
//           </div>
//         )}
//       </DashboardLayout>

//       {/* FLOATING AI BUTTON */}
//       <button className="ai-float-btn" onClick={() => d.setShowAIChat(true)}>
//         ✨
//       </button>
//       <button
//   className="ai-float-btn"
//   style={{ right: "110px" }}
//   onClick={() => window.location.href = "/mychat"}
// >
//   🗨️
// </button>


//       {/* CHAT TOAST NOTIFICATION */}
      // {chatToast && (
      //   <div
      //     onClick={() => window.location.href = "/mychat"}
      //     style={{
      //       position: "fixed",
      //       bottom: "90px",
      //       right: "24px",
      //       background: "white",
      //       border: "1px solid rgba(44,82,130,0.2)",
      //       borderRadius: "14px",
      //       padding: "12px 16px",
      //       boxShadow: "0 8px 30px rgba(0,0,0,0.13)",
      //       zIndex: 999999,
      //       display: "flex",
      //       alignItems: "center",
      //       gap: "12px",
      //       maxWidth: "300px",
      //       cursor: "pointer",
      //       animation: "toastSlideUp 0.3s ease-out"
      //     }}
      //   >
      //     <div style={{ fontSize: "22px" }}>💬</div>
      //     <div style={{ flex: 1 }}>
      //       <div style={{ fontWeight: 700, color: "#2d3748", fontSize: "14px", marginBottom: "2px" }}>
      //         {chatToast.name}
      //       </div>
      //       <div style={{ fontSize: "13px", color: "#718096" }}>
      //         {chatToast.message}
      //       </div>
      //     </div>
      //     <button
      //       onClick={(e) => { e.stopPropagation(); setChatToast(null); }}
      //       style={{ background: "none", border: "none", color: "#a0aec0", cursor: "pointer", fontSize: "16px", padding: 0, lineHeight: 1 }}
      //     >
      //       ✕
      //     </button>
      //   </div>
      // )}

      // {/* REMINDER POPUP */}
//       {d.showReminderPopup && d.reminderData?.hasReminder && (
//         <div className="modal-overlay-ultra">
//           <div className="reminder-popup-ultra">
//             <div className="reminder-popup-header">
//               <span className="reminder-icon">🔔</span>
//               <div>
//                 <h3 className="reminder-title">Reflection Reminder</h3>
//                 <p className="reminder-subtitle">
//                   {d.reminderData.userMessage}
//                 </p>
//               </div>
//             </div>

//             <div className="reminder-body">
//               <ul className="reminder-list-ultra">
//                 {d.reminderData.previousPlans.map((item, idx) => (
//                   <li key={idx} className="reminder-task-item">
//                     {item}
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             <div className="reminder-footer">
//               <button
//                 className="submit-btn-ultra"
//                 onClick={() => {
//                   d.setShowReminderPopup(false);
//                   d.setHasNewReminder(false);
//                   localStorage.setItem("reminderDismissedDate", new Date().toDateString());
//                 }}
//               >
//                 Got it
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* REMINDER SIDE PANEL */}
//       {d.showReminderPanel && (
//         <div className="reminder-side-panel-ultra">
//           <div className="reminder-side-header">
//             <div className="side-title-wrap">
//               <span className="reminder-icon">🔔</span>
//               <div>
//                 <h3>Reminders</h3>
//                 <p>Review your previous plans quickly.</p>
//               </div>
//             </div>
//             <button
//               className="side-close-btn"
//               onClick={() => d.setShowReminderPanel(false)}
//             >
//               ✕
//             </button>
//           </div>

//           <div className="side-reminder-options">
//             <button onClick={() => d.fetchReminder("daily", { showPopup: false })}>
//               Daily Reminder
//             </button>
//             <button onClick={() => d.fetchReminder("weekly", { showPopup: false })}>
//               Weekly Reminder
//             </button>
//             <button onClick={() => d.fetchReminder("monthly", { showPopup: false })}>
//               Monthly Reminder
//             </button>
//           </div>

//           <div className="side-reminder-content">
//             {d.reminderData?.hasReminder ? (
//               <>
//                 <p className="side-reminder-message">
//                   {d.reminderData.userMessage}
//                 </p>
//                 <ul>
//                   {d.reminderData.previousPlans.map((plan, i) => (
//                     <li key={i} className="reminder-task-item">
//                       {plan}
//                     </li>
//                   ))}
//                 </ul>
//               </>
//             ) : (
//               <p className="side-no-reminder">No reminder available.</p>
//             )}
//           </div>
//         </div>
//       )}

//       {/* AI CHAT POPUP */}
//       {d.showAIChat && (
//         <div className="ai-chat-container">
//           <div className="ai-chat-header">
//             <span>AI Assistant</span>
//             <button
//               className="ai-close-btn"
//               onClick={() => d.setShowAIChat(false)}
//             >
//               ×
//             </button>
//           </div>

//           <div className="ai-chat-body">
//             {d.chatMessages.map((msg, i) => (
//               <div
//                 key={i}
//                 className={`ai-chat-bubble ${
//                   msg.sender === "user" ? "user-msg" : "ai-msg"
//                 }`}
//               >
//                 {msg.text}
//               </div>
//             ))}
//           </div>

//           <div className="ai-chat-footer">
//             <input
//               type="text"
//               placeholder="Ask anything..."
//               value={d.chatInput}
//               onChange={(e) => d.setChatInput(e.target.value)}
//               onKeyDown={(e) => e.key === "Enter" && d.sendChat()}
//             />
//             <button onClick={d.sendChat}>Send</button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }


// // src/pages/dashboard/Dashboard.jsx
// import "../../styles/dashboard.css";
// import DashboardLayout from "./DashboardLayout";
// import useDashboard from "./useDashboard";

// import MyReflection from "../MyReflection/MyReflection";
// import TeamView from "../TeamView/TeamView";
// import Timesheet from "../Timesheet/Timesheet";
// import MySkills from "../MySkills/MySkills";
// import Report from "../Report/Report";

// import ReflectionForm from "./ReflectionForm";

// export default function Dashboard() {
//   const d = useDashboard();

//   if (!d.isLoggedIn) {
//     window.location.href = "/";
//     return null;
//   }

//   const name = d.profile?.Name || "User";
//   const firstLetter = d.email?.charAt(0).toUpperCase() || "U";

//   const logout = () => {
//     localStorage.clear();
//     window.location.href = "/";
//   };

//   const handleNavClick = (page) => {
//     d.setActivePage(page);
//     if (d.isMobile) d.setIsSidebarOpen(false);
//   };

//   const getPageTitle = () => {
//     const titles = {
//       reflection: "Reflection Workspace",
//       myreflection: "My Reflections",
//       team: "Team Insights",
//       timesheet: "Timesheet",
//       myskills: "My Skills",
//       report: "Reports",
//     };
//     return titles[d.activePage] || "Dashboard";
//   };

//   const getSubtitle = () =>
//     d.activePage === "reflection"
//       ? `Welcome back, ${name}. Capture your reflections with premium clarity.`
//       : "";

//   // Conditional sidebar items — Team View only for RoleID 1 or 2
//   const navItems = [
//     ["reflection", "💎", "Reflection"],
//     ["myreflection", "👤", "My Reflections"],
//     ...(d.userRole === 1 || d.userRole === 2 ? [["team", "👑", "Team View"]] : []),
//     ["timesheet", "⏱️", "Timesheet"],
//     ["myskills", "🧠", "My Skills"],
//     ["report", "📊", "Report"],
//   ];

//   return (
//     <>
//       <DashboardLayout
//         sidebar={
//           <aside
//             className={`diamond-sidebar ${
//               d.isMobile && d.isSidebarOpen ? "sidebar-open-ultra" : ""
//             }`}
//           >
//             <div className="sidebar-header-ultra logo-only-center">
//   <img
//     src="/logo.png"
//     alt="Suryojasvi Logo"
//     className="sidebar-main-logo"
//   />
// </div>


//             <nav className="ultra-nav">
//               {navItems.map(([key, icon, label]) => (
//                 <button
//                   key={key}
//                   className={`nav-item-ultra ${d.activePage === key ? "active" : ""}`}
//                   onClick={() => handleNavClick(key)}
//                 >
//                   <div className="nav-icon-ultra">{icon}</div>
//                   <span>{label}</span>
//                 </button>
//               ))}
//             </nav>

//             <div className="sidebar-footer-ultra">
//               <div className="user-profile-ultra">
//                 <div className="user-email-ultra">{d.email}</div>
//                 <div className="user-team-ultra">
//                   Team: <strong>{d.team?.length || 0}</strong>
//                 </div>
//               </div>
//               <button className="logout-btn-ultra" onClick={logout}>
//                 Logout 🚪
//               </button>
//             </div>
//           </aside>
//         }

//         header={
//           <header className="diamond-header header-flex-ultra">
//             <div className="header-content-ultra">
//               <div className="page-kicker-ultra">Premium Dashboard</div>
//               <h1 className="page-title-ultra">{getPageTitle()}</h1>
//               <p className="page-subtitle-ultra">{getSubtitle()}</p>
//             </div>

//             <div className="header-user-chip">
//               <span className="chip-text">{name}</span>
//               <button
//                 className={`reminder-bell-btn ${d.hasNewReminder ? "has-reminder" : ""}`}
//                 onClick={() => d.setShowReminderPanel(true)}
//               >
//                 🔔
//               </button>
//             </div>
//           </header>
//         }

//         footer={
//           <footer className="diamond-footer">
//             <div className="footer-content">
//               <div className="footer-bottom">
//                 <div className="copyright">
//                   © {new Date().getFullYear()} Suryojasvi Reflection Tracker
//                 </div>
//               </div>
//             </div>
//           </footer>
//         }
//       >
//         {d.activePage === "reflection" && <ReflectionForm {...d} />}

//         {d.activePage === "myreflection" && (
//           <div className="diamond-card">
//             <div className="card-body-ultra">
//               <MyReflection />
//             </div>
//           </div>
//         )}

//         {d.activePage === "team" && (
//           d.userRole === 1 || d.userRole === 2 ? (
//             <div className="diamond-card">
//               <div className="card-body-ultra">
//                 <TeamView loggedEmail={d.email} teamData={d.team} />
//               </div>
//             </div>
//           ) : (
//             <div className="empty-state-ultra">No access to Team View.</div>
//           )
//         )}

//         {d.activePage === "timesheet" && (
//           <div className="diamond-card">
//             <div className="card-header-ultra">
//               <h2 className="card-title-ultra">Timesheet</h2>
//             </div>
//             <div className="card-body-ultra">
//               <Timesheet />
//             </div>
//           </div>
//         )}

//         {d.activePage === "myskills" && (
//           <div className="diamond-card">
//             <div className="card-header-ultra">
//               <h2 className="card-title-ultra">My Skills</h2>
//             </div>
//             <div className="card-body-ultra">
//               <MySkills />
//             </div>
//           </div>
//         )}

//         {d.activePage === "report" && (
//           <div className="diamond-card">
//             <div className="card-header-ultra">
//               <h2 className="card-title-ultra">Reports</h2>
//             </div>
//             <div className="card-body-ultra">
//               <Report />
//             </div>
//           </div>
//         )}
//       </DashboardLayout>

//       {/* FLOATING AI BUTTON */}
//       <button className="ai-float-btn" onClick={() => d.setShowAIChat(true)}>
//         ✨
//       </button>
//       <button
//   className="ai-float-btn"
//   style={{ right: "110px" }}
//   onClick={() => window.location.href = "/mychat"}
// >
//   🗨️
// </button>


//       {/* CHAT TOAST NOTIFICATION */}
      // {chatToast && (
      //   <div
      //     onClick={() => window.location.href = "/mychat"}
      //     style={{
      //       position: "fixed",
      //       bottom: "90px",
      //       right: "24px",
      //       background: "white",
      //       border: "1px solid rgba(44,82,130,0.2)",
      //       borderRadius: "14px",
      //       padding: "12px 16px",
      //       boxShadow: "0 8px 30px rgba(0,0,0,0.13)",
      //       zIndex: 999999,
      //       display: "flex",
      //       alignItems: "center",
      //       gap: "12px",
      //       maxWidth: "300px",
      //       cursor: "pointer",
      //       animation: "toastSlideUp 0.3s ease-out"
      //     }}
      //   >
      //     <div style={{ fontSize: "22px" }}>💬</div>
      //     <div style={{ flex: 1 }}>
      //       <div style={{ fontWeight: 700, color: "#2d3748", fontSize: "14px", marginBottom: "2px" }}>
      //         {chatToast.name}
      //       </div>
      //       <div style={{ fontSize: "13px", color: "#718096" }}>
      //         {chatToast.message}
      //       </div>
      //     </div>
      //     <button
      //       onClick={(e) => { e.stopPropagation(); setChatToast(null); }}
      //       style={{ background: "none", border: "none", color: "#a0aec0", cursor: "pointer", fontSize: "16px", padding: 0, lineHeight: 1 }}
      //     >
      //       ✕
      //     </button>
      //   </div>
      // )}

      // {/* REMINDER POPUP */}
//       {d.showReminderPopup && d.reminderData?.hasReminder && (
//         <div className="modal-overlay-ultra">
//           <div className="reminder-popup-ultra">
//             <div className="reminder-popup-header">
//               <span className="reminder-icon">🔔</span>
//               <div>
//                 <h3 className="reminder-title">Reflection Reminder</h3>
//                 <p className="reminder-subtitle">
//                   {d.reminderData.userMessage}
//                 </p>
//               </div>
//             </div>

//             <div className="reminder-body">
//               <ul className="reminder-list-ultra">
//                 {d.reminderData.previousPlans.map((item, idx) => (
//                   <li key={idx} className="reminder-task-item">
//                     {item}
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             <div className="reminder-footer">
//               <button
//                 className="submit-btn-ultra"
//                 onClick={() => {
//                   d.setShowReminderPopup(false);
//                   d.setHasNewReminder(false);
//                   localStorage.setItem("reminderDismissedDate", new Date().toDateString());
//                 }}
//               >
//                 Got it
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* REMINDER SIDE PANEL */}
//       {d.showReminderPanel && (
//         <div className="reminder-side-panel-ultra">
//           <div className="reminder-side-header">
//             <div className="side-title-wrap">
//               <span className="reminder-icon">🔔</span>
//               <div>
//                 <h3>Reminders</h3>
//                 <p>Review your previous plans quickly.</p>
//               </div>
//             </div>
//             <button
//               className="side-close-btn"
//               onClick={() => d.setShowReminderPanel(false)}
//             >
//               ✕
//             </button>
//           </div>

//           <div className="side-reminder-options">
//             <button onClick={() => d.fetchReminder("daily", { showPopup: false })}>
//               Daily Reminder
//             </button>
//             <button onClick={() => d.fetchReminder("weekly", { showPopup: false })}>
//               Weekly Reminder
//             </button>
//             <button onClick={() => d.fetchReminder("monthly", { showPopup: false })}>
//               Monthly Reminder
//             </button>
//           </div>

//           <div className="side-reminder-content">
//             {d.reminderData?.hasReminder ? (
//               <>
//                 <p className="side-reminder-message">
//                   {d.reminderData.userMessage}
//                 </p>
//                 <ul>
//                   {d.reminderData.previousPlans.map((plan, i) => (
//                     <li key={i} className="reminder-task-item">
//                       {plan}
//                     </li>
//                   ))}
//                 </ul>
//               </>
//             ) : (
//               <p className="side-no-reminder">No reminder available.</p>
//             )}
//           </div>
//         </div>
//       )}

//       {/* AI CHAT POPUP */}
//       {d.showAIChat && (
//         <div className="ai-chat-container">
//           <div className="ai-chat-header">
//             <span>AI Assistant</span>
//             <button
//               className="ai-close-btn"
//               onClick={() => d.setShowAIChat(false)}
//             >
//               ×
//             </button>
//           </div>

//           <div className="ai-chat-body">
//             {d.chatMessages.map((msg, i) => (
//               <div
//                 key={i}
//                 className={`ai-chat-bubble ${
//                   msg.sender === "user" ? "user-msg" : "ai-msg"
//                 }`}
//               >
//                 {msg.text}
//               </div>
//             ))}
//           </div>

//           <div className="ai-chat-footer">
//             <input
//               type="text"
//               placeholder="Ask anything..."
//               value={d.chatInput}
//               onChange={(e) => d.setChatInput(e.target.value)}
//               onKeyDown={(e) => e.key === "Enter" && d.sendChat()}
//             />
//             <button onClick={d.sendChat}>Send</button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }




// src/pages/dashboard/Dashboard.jsx
import "../../styles/dashboard.css";
import ReactDOM from "react-dom";
import DashboardLayout from "./DashboardLayout";
import useDashboard from "./useDashboard";

import MyReflection from "../MyReflection/MyReflection";
import TeamView from "../TeamView/TeamView";
import Timesheet from "../Timesheet/Timesheet";
import MySkills from "../MySkills/MySkills";
import Report from "../Report/Report";

import ReflectionForm from "./ReflectionForm";
import { useState, useEffect, useRef } from "react";

const API = "https://suryojasvi-reflection-api.wyzmindz.com/api";

/* ── INLINE PREMIUM POPUP ─────────────────────────────────────── */
const popupStyles = `
@keyframes sp-overlay-in { from{opacity:0} to{opacity:1} }
@keyframes sp-card-in { from{opacity:0;transform:scale(0.55) translateY(28px)} to{opacity:1;transform:scale(1) translateY(0)} }
@keyframes sp-circle-draw { to{stroke-dashoffset:0} }
@keyframes sp-tick-draw { to{stroke-dashoffset:0} }
@keyframes sp-glow-pulse { 0%,100%{opacity:.65;transform:scale(1)} 50%{opacity:1;transform:scale(1.13)} }
@keyframes sp-burst { 0%{opacity:1;transform:translate(0,0) scale(1)} 100%{opacity:0;transform:translate(var(--tx,20px),var(--ty,-28px)) scale(.2)} }
@keyframes sp-progress { from{transform:scaleX(1)} to{transform:scaleX(0)} }

.sp-overlay{position:fixed;inset:0;background:rgba(8,12,26,.58);backdrop-filter:blur(7px);-webkit-backdrop-filter:blur(7px);z-index:9999999;display:flex;align-items:center;justify-content:center;animation:sp-overlay-in .18s ease}
.sp-card{position:relative;background:linear-gradient(150deg,#fff 0%,#f5f8ff 100%);border-radius:26px;padding:46px 38px 34px;width:350px;max-width:92vw;text-align:center;overflow:hidden;box-shadow:0 0 0 1.5px rgba(255,255,255,.85) inset,0 28px 70px rgba(0,0,0,.17),0 0 55px var(--sp-glow,rgba(34,197,94,.22));animation:sp-card-in .38s cubic-bezier(.34,1.56,.64,1);border:1.5px solid rgba(255,255,255,.65)}
.sp-card::before{content:"";position:absolute;top:0;left:0;right:0;height:4px;background:var(--sp-accent,#22c55e);border-radius:26px 26px 0 0}
.sp-card::after{content:"";position:absolute;inset:0;background:radial-gradient(ellipse at 20% 0%,var(--sp-glow,rgba(34,197,94,.13)) 0%,transparent 60%),radial-gradient(ellipse at 80% 100%,var(--sp-glow,rgba(34,197,94,.08)) 0%,transparent 60%);pointer-events:none;border-radius:26px}
.sp-icon-ring{position:relative;width:88px;height:88px;margin:0 auto 18px}
.sp-icon-glow{position:absolute;inset:-8px;background:var(--sp-glow,rgba(34,197,94,.28));border-radius:50%;filter:blur(13px);animation:sp-glow-pulse 2s ease-in-out infinite}
.sp-svg{position:relative;z-index:1;width:88px;height:88px}
.sp-circle{stroke:var(--sp-accent,#22c55e);stroke-width:2.5;stroke-dasharray:166;stroke-dashoffset:166;stroke-linecap:round;fill:none;animation:sp-circle-draw .6s cubic-bezier(.65,0,.45,1) .1s forwards}
.sp-tick{stroke:var(--sp-accent,#22c55e);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:50;stroke-dashoffset:50;fill:none;animation:sp-tick-draw .38s ease .55s forwards}
.sp-sparkles{position:absolute;top:88px;left:50%;transform:translateX(-50%);width:96px;height:96px;pointer-events:none}
.sp-dot{position:absolute;left:50%;top:50%;width:7px;height:7px;border-radius:50%;background:var(--sp-accent,#22c55e);opacity:0}
.sp-d1{animation:sp-burst .65s ease .6s forwards;--tx:-24px;--ty:-30px}
.sp-d2{animation:sp-burst .65s ease .65s forwards;--tx:22px;--ty:-26px}
.sp-d3{animation:sp-burst .65s ease .7s forwards;--tx:-34px;--ty:7px}
.sp-d4{animation:sp-burst .65s ease .72s forwards;--tx:32px;--ty:5px}
.sp-d5{animation:sp-burst .65s ease .68s forwards;--tx:-17px;--ty:26px}
.sp-d6{animation:sp-burst .65s ease .75s forwards;--tx:19px;--ty:24px}
.sp-label{font-family:"Segoe UI","SF Pro Display",system-ui,sans-serif;font-size:21px;font-weight:800;color:#1a202c;letter-spacing:-.3px;margin-bottom:9px;position:relative;z-index:1}
.sp-msg{font-family:"Segoe UI",system-ui,sans-serif;font-size:14px;color:#64748b;line-height:1.6;margin:0 0 26px;position:relative;z-index:1}
.sp-btn{display:inline-flex;align-items:center;gap:8px;background:var(--sp-accent,#22c55e);color:#fff;border:none;border-radius:11px;padding:11px 26px;font-size:14px;font-weight:700;letter-spacing:.3px;cursor:pointer;position:relative;z-index:1;transition:transform .15s,box-shadow .15s;box-shadow:0 6px 18px var(--sp-glow,rgba(34,197,94,.38))}
.sp-btn:hover{transform:translateY(-2px);box-shadow:0 10px 26px var(--sp-glow,rgba(34,197,94,.48))}
.sp-progress{position:absolute;bottom:0;left:0;height:3px;width:100%;background:var(--sp-accent,#22c55e);opacity:.45;border-radius:0 0 26px 26px;transform-origin:left;animation:sp-progress 3.5s linear forwards}
`;

const POPUP_CONFIG = {
  success: { accent: "#22c55e", glow: "rgba(34,197,94,.25)", label: "Success" },
  error:   { accent: "#ef4444", glow: "rgba(239,68,68,.22)",  label: "Error"   },
  warning: { accent: "#f59e0b", glow: "rgba(245,158,11,.22)", label: "Warning" },
  info:    { accent: "#3b82f6", glow: "rgba(59,130,246,.22)", label: "Info"    },
};

function PremiumPopup({ popup, onClose }) {
  useEffect(() => {
    // Inject styles into <head> once
    if (!document.getElementById("sp-styles")) {
      const tag = document.createElement("style");
      tag.id = "sp-styles";
      tag.textContent = popupStyles;
      document.head.appendChild(tag);
    }
  }, []);

  useEffect(() => {
    if (!popup) return;
    if (popup.type === "success" || popup.type === "info") {
      const t = setTimeout(onClose, 3500);
      return () => clearTimeout(t);
    }
  }, [popup, onClose]);

  if (!popup) return null;
  const cfg = POPUP_CONFIG[popup.type] || POPUP_CONFIG.success;
  const isSuccess = popup.type === "success";
  const isError   = popup.type === "error";

  return ReactDOM.createPortal(
    <div className="sp-overlay" onClick={onClose}>
      <div
        className="sp-card"
        style={{ "--sp-accent": cfg.accent, "--sp-glow": cfg.glow }}
        onClick={e => e.stopPropagation()}
      >
        <div className="sp-icon-ring">
          <div className="sp-icon-glow" />
          <svg className="sp-svg" viewBox="0 0 52 52">
            <circle className="sp-circle" cx="26" cy="26" r="25" />
            {isSuccess && <path className="sp-tick" fill="none" d="M14 27l9 9 15-18" />}
            {isError   && <path className="sp-tick" fill="none" strokeWidth="3" d="M17 17 35 35M35 17 17 35" />}
            {!isSuccess && !isError && <path className="sp-tick" fill="none" strokeWidth="3.5" d="M26 16v14M26 35v2" />}
          </svg>
        </div>

        <div className="sp-sparkles">
          <span className="sp-dot sp-d1"/><span className="sp-dot sp-d2"/>
          <span className="sp-dot sp-d3"/><span className="sp-dot sp-d4"/>
          <span className="sp-dot sp-d5"/><span className="sp-dot sp-d6"/>
        </div>

        <div className="sp-label">{popup.title || cfg.label}</div>
        {popup.message && <p className="sp-msg">{popup.message}</p>}

        <button className="sp-btn" onClick={onClose}>
          Got it&nbsp;
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </button>

        {(popup.type === "success" || popup.type === "info") && (
          <div className="sp-progress" />
        )}
      </div>
    </div>,
    document.body
  );
}
/* ── END INLINE PREMIUM POPUP ─────────────────────────────────── */

export default function Dashboard() {
  const d = useDashboard();
  const email = localStorage.getItem("email");
  const [chatUnreadTotal, setChatUnreadTotal] = useState(0);
  const [chatToast, setChatToast] = useState(null); // { name, message }
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const chatWsRef = useRef(null);

  // Poll unread counts every 15s
  useEffect(() => {
    if (!email) return;
    const fetchUnread = async () => {
      try {
        const res = await fetch(`${API}/chat/unread-counts?viewer_email=${email}`);
        const data = await res.json();
        const total = Object.values(data).reduce((a, b) => a + b, 0);
        setChatUnreadTotal(total);
      } catch (err) { /* silent */ }
    };
    fetchUnread();
    const interval = setInterval(fetchUnread, 15000);
    return () => clearInterval(interval);
  }, [email]);

  // WebSocket for instant unread bump + toast notification
  useEffect(() => {
    if (!email) return;

    const ws = new WebSocket(`wss://suryojasvi-reflection-api.wyzmindz.com/ws/chat?email=${email}`);
    chatWsRef.current = ws;

    ws.onmessage = async (event) => {
      const data = JSON.parse(event.data);

      // Only react to incoming new messages (not own sends)
      if (data.type === "new_message" && data.is_unread) {
        // Bump badge count immediately
        setChatUnreadTotal(prev => prev + 1);

        // Fetch sender name from chat list for the toast
        try {
          const res = await fetch(`${API}/chat/list?viewer_email=${email}`);
          const chats = await res.json();
          const chat = chats.find(c => c.chat_guid === data.chat_guid);
          const name = chat?.participant_name || chat?.participant_email || data.sender_email;
          const preview = (data.message || "").length > 55
            ? data.message.slice(0, 55) + "…"
            : data.message;

          setChatToast({ name, message: preview });
          setTimeout(() => setChatToast(null), 4500);
        } catch (err) {
          // fallback toast with email
          const preview = (data.message || "").slice(0, 55);
          setChatToast({ name: data.sender_email, message: preview });
          setTimeout(() => setChatToast(null), 4500);
        }
      }
    };

    return () => ws.close();
  }, [email]);


  if (!d.isLoggedIn) {
    window.location.href = "/";
    return null;
  }

  const name = d.profile?.Name || "User";
  // eslint-disable-next-line no-unused-vars
  const firstLetter = d.email?.charAt(0).toUpperCase() || "U";

  const logout = () => {
    setShowLogoutConfirm(true);
  };

  const confirmLogout = () => {
    localStorage.clear();
    sessionStorage.removeItem("reminderShown"); // reset so reminder shows on next login
    window.location.href = "/"; // ✅ redirect to login page
  };

  const handleNavClick = (page) => {
    d.setActivePage(page);
    if (d.isMobile) d.setIsSidebarOpen(false);
  };

  const getPageTitle = () => {
    const titles = {
      reflection: "Reflection Workspace",
      myreflection: "My Reflections",
      team: "Team Insights",
      timesheet: "Timesheet",
      myskills: "My Skills",
      report: "Reports",
    };
    return titles[d.activePage] || "Dashboard";
  };

  const getSubtitle = () =>
    d.activePage === "reflection"
      ? `Welcome back, ${name}. Capture your reflections with premium clarity.`
      : "";

  // Conditional sidebar items — Team View only for RoleID 1 or 2
  const navItems = [
    ["reflection", "💎", "Reflection"],
    ["myreflection", "👤", "My Reflections"],
    ...(d.userRole === 1 || d.userRole === 2 ? [["team", "👑", "Team View"]] : []),
    ["timesheet", "⏱️", "Timesheet"],
    ["myskills", "🧠", "My Skills"],
    ["report", "📊", "Report"],
  ];

  return (
    <>
      <DashboardLayout
        sidebar={
          <aside
            className={`diamond-sidebar ${
              d.isMobile && d.isSidebarOpen ? "sidebar-open-ultra" : ""
            }`}
          >
            <div className="sidebar-header-ultra logo-only-center">
  <a href="https://suryojasvigroup.com/#home" target="_blank" rel="noopener noreferrer" style={{ display: "block", cursor: "pointer" }}>
    <img
      src="/logo.png"
      alt="Suryojasvi Logo"
      className="sidebar-main-logo"
    />
  </a>
</div>


            <nav className="ultra-nav">
              {navItems.map(([key, icon, label]) => (
                <button
                  key={key}
                  className={`nav-item-ultra ${d.activePage === key ? "active" : ""}`}
                  onClick={() => handleNavClick(key)}
                >
                  <div className="nav-icon-ultra">{icon}</div>
                  <span>{label}</span>
                </button>
              ))}
            </nav>

            <div className="sidebar-footer-ultra">
              <div className="user-profile-ultra">
                <div className="user-email-ultra">{d.email}</div>
                <div className="user-team-ultra">
                  Team: <strong>{d.team?.length || 0}</strong>
                </div>
              </div>
              <button className="logout-btn-ultra" onClick={logout}>
                Logout 🚪
              </button>
            </div>
          </aside>
        }

        header={
          <>
            {/* Mobile sidebar overlay backdrop */}
            {d.isMobile && d.isSidebarOpen && (
              <div
                className="mobile-sidebar-overlay"
                onClick={() => d.setIsSidebarOpen(false)}
              />
            )}

            <header className="diamond-header header-flex-ultra">
              {/* Hamburger — only visible on mobile */}
              {d.isMobile && (
                <button
                  className="hamburger-btn"
                  onClick={() => d.setIsSidebarOpen(!d.isSidebarOpen)}
                  aria-label="Toggle menu"
                >
                  <span className={`ham-line ${d.isSidebarOpen ? "open" : ""}`} />
                  <span className={`ham-line ${d.isSidebarOpen ? "open" : ""}`} />
                  <span className={`ham-line ${d.isSidebarOpen ? "open" : ""}`} />
                </button>
              )}

              <div className="header-content-ultra">
                <div className="page-kicker-ultra">Premium Dashboard</div>
                <h1 className="page-title-ultra">{getPageTitle()}</h1>
                <p className="page-subtitle-ultra">{getSubtitle()}</p>
              </div>

              <div className="header-user-chip">
                <span className="chip-text">{name}</span>
                <button
                  className={`reminder-bell-btn ${d.hasNewReminder ? "has-reminder" : ""}`}
                  onClick={() => d.setShowReminderPanel(true)}
                >
                  🔔
                </button>
              </div>
            </header>
          </>
        }

        footer={
          <footer className="diamond-footer">
            <div className="footer-content">
              <div className="footer-bottom">
                <div className="copyright">
                  © {new Date().getFullYear()} Suryojasvi Reflection Tracker
                </div>
              </div>
            </div>
          </footer>
        }
      >
        {d.activePage === "reflection" && <ReflectionForm {...d} />}

        {d.activePage === "myreflection" && (
          <div className="diamond-card">
            <div className="card-body-ultra">
              <MyReflection />
            </div>
          </div>
        )}

        {d.activePage === "team" && (
          d.userRole === 1 || d.userRole === 2 ? (
            <div className="diamond-card">
              <div className="card-body-ultra">
                <TeamView loggedEmail={d.email} teamData={d.team} />
              </div>
            </div>
          ) : (
            <div className="empty-state-ultra">No access to Team View.</div>
          )
        )}

        {d.activePage === "timesheet" && (
          <div className="diamond-card">
            <div className="card-header-ultra">
              <h2 className="card-title-ultra">Timesheet</h2>
            </div>
            <div className="card-body-ultra">
              <Timesheet />
            </div>
          </div>
        )}

        {d.activePage === "myskills" && (
          <div className="diamond-card">
            <div className="card-header-ultra">
              <h2 className="card-title-ultra">My Skills</h2>
            </div>
            <div className="card-body-ultra">
              <MySkills />
            </div>
          </div>
        )}

        {d.activePage === "report" && (
          <div className="diamond-card">
            <div className="card-header-ultra">
              <h2 className="card-title-ultra">Reports</h2>
            </div>
            <div className="card-body-ultra">
              <Report />
            </div>
          </div>
        )}
      </DashboardLayout>

      {/* FLOATING AI BUTTON */}
      <button className="ai-float-btn" onClick={() => d.setShowAIChat(true)}>
        ✨
      </button>
      <button
        className="ai-float-btn"
        style={{ right: "110px", position: "fixed", overflow: "visible" }}
        onClick={() => window.location.href = "/mychat"}
      >
        🗨️
        {chatUnreadTotal > 0 && (
          <span style={{
            position: "absolute",
            top: "-6px",
            right: "-6px",
            background: "#e53e3e",
            color: "white",
            fontSize: "11px",
            fontWeight: "700",
            minWidth: "18px",
            height: "18px",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 4px",
            border: "2px solid white",
            boxShadow: "0 2px 6px rgba(229,62,62,0.5)",
            zIndex: 99999,
            pointerEvents: "none",
            lineHeight: 1,
          }}>
            {chatUnreadTotal > 99 ? "99+" : chatUnreadTotal}
          </span>
        )}
      </button>


      {/* CHAT TOAST NOTIFICATION */}
      {chatToast && (
        <div
          onClick={() => window.location.href = "/mychat"}
          style={{
            position: "fixed",
            bottom: "90px",
            right: "24px",
            background: "white",
            border: "1px solid rgba(44,82,130,0.2)",
            borderRadius: "14px",
            padding: "12px 16px",
            boxShadow: "0 8px 30px rgba(0,0,0,0.13)",
            zIndex: 999999,
            display: "flex",
            alignItems: "center",
            gap: "12px",
            maxWidth: "300px",
            cursor: "pointer",
            animation: "toastSlideUp 0.3s ease-out"
          }}
        >
          <div style={{ fontSize: "22px" }}>💬</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, color: "#2d3748", fontSize: "14px", marginBottom: "2px" }}>
              {chatToast.name}
            </div>
            <div style={{ fontSize: "13px", color: "#718096" }}>
              {chatToast.message}
            </div>
          </div>
          <button
            onClick={(e) => { e.stopPropagation(); setChatToast(null); }}
            style={{ background: "none", border: "none", color: "#a0aec0", cursor: "pointer", fontSize: "16px", padding: 0, lineHeight: 1 }}
          >
            ✕
          </button>
        </div>
      )}

      {/* REMINDER POPUP */}
      {d.showReminderPopup && d.reminderData?.hasReminder && (
        <div className="modal-overlay-ultra">
          <div className="reminder-popup-ultra">
            <div className="reminder-popup-header">
              <span className="reminder-icon">🔔</span>
              <div>
                <h3 className="reminder-title">Reflection Reminder</h3>
                <p className="reminder-subtitle">
                  {d.reminderData.userMessage}
                </p>
              </div>
            </div>

            <div className="reminder-body">
              <ul className="reminder-list-ultra">
                {d.reminderData.previousPlans.map((item, idx) => (
                  <li key={idx} className="reminder-task-item">
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="reminder-footer">
              <button
                className="submit-btn-ultra"
                onClick={() => {
                  d.setShowReminderPopup(false);
                  d.setHasNewReminder(false);
                  localStorage.setItem("reminderDismissedDate", new Date().toDateString());
                }}
              >
                Got it
              </button>
            </div>
          </div>
        </div>
      )}

      {/* REMINDER SIDE PANEL */}
      {d.showReminderPanel && (
        <div className="reminder-side-panel-ultra">
          <div className="reminder-side-header">
            <div className="side-title-wrap">
              <span className="reminder-icon">🔔</span>
              <div>
                <h3>Reminders</h3>
                <p>Review your previous plans quickly.</p>
              </div>
            </div>
            <button
              className="side-close-btn"
              onClick={() => d.setShowReminderPanel(false)}
            >
              ✕
            </button>
          </div>

          <div className="side-reminder-options">
            <button onClick={() => d.fetchReminder("daily", { showPopup: false })}>
              Daily Reminder
            </button>
            <button onClick={() => d.fetchReminder("weekly", { showPopup: false })}>
              Weekly Reminder
            </button>
            <button onClick={() => d.fetchReminder("monthly", { showPopup: false })}>
              Monthly Reminder
            </button>
          </div>

          <div className="side-reminder-content">
            {d.reminderData?.hasReminder ? (
              <>
                <p className="side-reminder-message">
                  {d.reminderData.userMessage}
                </p>
                <ul>
                  {d.reminderData.previousPlans.map((plan, i) => (
                    <li key={i} className="reminder-task-item">
                      {plan}
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              <p className="side-no-reminder">No reminder available.</p>
            )}
          </div>
        </div>
      )}

      {/* AI CHAT POPUP */}
      {d.showAIChat && (
        <div className="ai-chat-container">
          <div className="ai-chat-header">
            <span>AI Assistant</span>
            <button
              className="ai-close-btn"
              onClick={() => d.setShowAIChat(false)}
            >
              ×
            </button>
          </div>

          <div className="ai-chat-body">
            {d.chatMessages.map((msg, i) => (
              <div
                key={i}
                className={`ai-chat-bubble ${
                  msg.sender === "user" ? "user-msg" : "ai-msg"
                }`}
              >
                {msg.text}
              </div>
            ))}
          </div>

          <div className="ai-chat-footer">
            <input
              type="text"
              placeholder="Ask anything..."
              value={d.chatInput}
              onChange={(e) => d.setChatInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && d.sendChat()}
            />
            <button onClick={d.sendChat}>Send</button>
          </div>
        </div>
      )}

      {showLogoutConfirm && (
        <div className="logout-overlay">
          <div className="logout-confirm-box">
            <h3 className="logout-confirm-title">Logout</h3>
            <p className="logout-confirm-msg">Are you sure you want to logout?</p>
            <div className="logout-confirm-actions">
              <button className="logout-confirm-yes" onClick={confirmLogout}>Yes, Logout</button>
              <button className="logout-confirm-no" onClick={() => setShowLogoutConfirm(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* PREMIUM SUCCESS POPUP */}
      <PremiumPopup popup={d.successPopup} onClose={() => d.setSuccessPopup(null)} />
    </>
  );
}
